/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { NodoDto } from ".././models";

export const getAziende = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoDto[]>> => {
  return axios.get(`/api/aziende`, options);
};

export const getGetAziendeQueryKey = () => [`/api/aziende`] as const;

export const getGetAziendeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAziende>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAziende>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<Awaited<ReturnType<typeof getAziende>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAziendeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAziende>>> = ({
    signal,
  }) => getAziende({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetAziendeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAziende>>
>;
export type GetAziendeQueryError = AxiosError<unknown>;

export const useGetAziende = <
  TData = Awaited<ReturnType<typeof getAziende>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAziende>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAziendeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getAziendePortale = (
  portale: 1 | 2 | 3,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoDto[]>> => {
  return axios.get(`/api/portali/${portale}/aziende`, options);
};

export const getGetAziendePortaleQueryKey = (portale: 1 | 2 | 3) =>
  [`/api/portali/${portale}/aziende`] as const;

export const getGetAziendePortaleQueryOptions = <
  TData = Awaited<ReturnType<typeof getAziendePortale>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAziendePortale>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getAziendePortale>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAziendePortaleQueryKey(portale);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAziendePortale>>
  > = ({ signal }) => getAziendePortale(portale, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!portale, ...queryOptions };
};

export type GetAziendePortaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAziendePortale>>
>;
export type GetAziendePortaleQueryError = AxiosError<unknown>;

export const useGetAziendePortale = <
  TData = Awaited<ReturnType<typeof getAziendePortale>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAziendePortale>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAziendePortaleQueryOptions(portale, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetAziende = () =>
  //@ts-ignore
  useGetAziende(...([] as any[]));

export const __$$useGetAziendePortale = () =>
  //@ts-ignore
  useGetAziendePortale(...([] as any[]));
